import { Calendar } from "primereact/calendar"
import { classNames } from "primereact/utils"
import { Controller } from "react-hook-form"

interface IDate {
    label?: string,
    name: string,
    defaultValue?: string | number,
    control: any,
    error?: string,
    required?: boolean,
    disabled?: boolean,
    placeholder?: string,
    column?: number,
    maxDate?: Date,
    minDate?: Date,
    type?: string
}

export const JVDate = (props: IDate) => {
    const className = props.column ? `field col-12 md:col-${12 / props.column}` : "field col-12 md:col-6";
    const type = props.type ? props.type : "date";
    return (
        <div className={className}>
            {props.label && <label htmlFor={props.name}>{props.label}{props.required && <span style={{ color: 'red' }}>*</span>}</label>}
            <Controller name={props.name} control={props.control} defaultValue={props.defaultValue ? props.defaultValue : ''} render={({ field, fieldState }) => (
                <Calendar {...field} view={type} disabled={props.disabled} className={classNames({ 'p-invalid': fieldState.invalid })} placeholder={props.placeholder}
                    minDate={props.minDate} maxDate={props.maxDate} showButtonBar dateFormat={type === "date" ? "mm-dd-yy" : (type === "year" ? "yy" : (type === "month" ? "mm" : "mm-dd-yy"))} showIcon />
            )} />
            <small className="p-error" >{props.error}</small>
        </div>
    );
}